/*
https://github.com/themesberg/flowbite-icons
Flowbite Icons is free and open-source under the MIT License.
*/
import React from 'react';

interface Props {
    readonly className?: string;
    readonly color?: string;
}

export default function CircleMedium({ className = null, color = '#434F54' }: Props) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <circle cx="8" cy="8" r="8" transform="matrix(1 0 0 -1 0 16)" fill="#DAE5E9" />
            <circle cx="6" cy="6" r="6" transform="matrix(1 0 0 -1 2 14)" fill={color} />
            <circle cx="4" cy="4" r="4" transform="matrix(1 0 0 -1 4 12)" fill="#DAE5E9" />
        </svg>
    );
}
